import { gql } from '@apollo/client';

export default gql`
  query getTodayEvents {
    getTodayEvents {
      ok
      error
      data {
        _id
        id
        branch
        title
        startDate
        endDate
        allDay
        reminder
        rRule
        exDate
        allowDrag

        autoNo
        docNo
        priority
        amount
        status

        bonos
        overtime
        absent
        cashin
        teamMembers

        customerId
        customerName
        customerNameAr
        customerPhone

        itemId
        itemName
        itemNameAr

        departmentId
        departmentName
        departmentNameAr
        departmentColor

        employeeId
        employeeName
        employeeNameAr
        employeeColor
        employeePhone
        workersIds

        projectId
        projectName
        projectNameAr
        projectColor
        resourseId
        resourseName
        resourseNameAr
        resourseColor

        contractId
        contractName
        contractNameAr

        retypeId
        retypeName
        retypeNameAr
        retypeColor

        retype2Id
        retype2Name
        retype2NameAr
        retype2Color

        invoiceId
        link
        sent
        paid
        invoiced
        procs

        refNo
        refType

        createdAt
        updatedAt
      }
    }
  }
`;
